(function () {
    class SettingSound extends PIXI.Container {
      constructor(json) {
        super();
  
        this._json = json;
  
        this._active = false;
  
        this._musicBarDown = false;
        this._effectsBarDown = false;
  
        this.lastPos = null;
        this.lastDiffence = null;
        this.musicPercent = 1;
        this.effectsPercent = 1;
  
        messageBus.subscribe(
          "spinner:GameConfigEvent",
          this.onGameConfigEvent.bind(this)
        );
        messageBus.subscribe(
          "audio:currentMuteState",
          this.onAudioStateChanged.bind(this)
        );
      }
  
      initialise() {
        this._onButton = resourceManager.get(this._json.onButtonId);
        this._offButton = resourceManager.get(this._json.offButtonId);
  
        this.sliderWidth = 40;
        this.backgroundWidth = 400;
        const sliderHeight = 30;
        const backgroundHeight = 10;
        const radius = 5;
  
        this._musicContainer = resourceManager.get(this._json.musicContainer);
        this._musicBackground = resourceManager.get(this._json.musicBackground);
        this._musicSlider = resourceManager.get(this._json.musicSlider);
        this._musicCounter = resourceManager.get(this._json.musicCounter);
        this._musicCounter.visible = false;
  
        this._musicBackground.beginFill(0xffffff);
        this._musicBackground.drawRoundedRect(
          0,
          0,
          this.backgroundWidth + this.sliderWidth / 2,
          backgroundHeight,
          radius
        );
        this._musicBackground.endFill();
  
        this._effectsContainer = resourceManager.get(this._json.effectsContainer);
        this._effectsBackground = resourceManager.get(
          this._json.effectsBackground
        );
        this._effectsSlider = resourceManager.get(this._json.effectsSlider);
        this._effectsCounter = resourceManager.get(this._json.effectsCounter);
        this._effectsCounter.visible = false;
  
        this._effectsBackground.beginFill(0xffffff);
        this._effectsBackground.drawRoundedRect(
          0,
          0,
          this.backgroundWidth + this.sliderWidth / 2,
          backgroundHeight,
          radius
        );
        this._effectsBackground.endFill();
  
        const self = this;
  
        this._musicSlider.interactive = true;
        this._musicSlider.touchmove = (e) => this.musicBarMove(e);
        this._musicSlider.mousemove = (e) => this.musicBarMove(e);
        this._musicSlider.mousedown = (e) => this.musicBarDown(e);
        this._musicSlider.mouseup = (e) => this.musicBarUp(e);
        this._musicSlider.mouseupoutside = (e) => this.musicBarUp(e);
        this._musicSlider.touchstart = (e) => this.musicBarDown(e);
        this._musicSlider.touchend = (e) => this.musicBarUp(e);
        this._musicSlider.touchendoutside = (e) => this.musicBarUp(e);
  
        this._effectsSlider.interactive = true;
        this._effectsSlider.touchmove = (e) => this.effectsBarMove(e);
        this._effectsSlider.mousemove = (e) => this.effectsBarMove(e);
        this._effectsSlider.mousedown = (e) => this.effectsBarDown(e);
        this._effectsSlider.mouseup = (e) => this.effectsBarUp(e);
        this._effectsSlider.mouseupoutside = (e) => this.effectsBarUp(e);
        this._effectsSlider.touchstart = (e) => this.effectsBarDown(e);
        this._effectsSlider.touchend = (e) => this.effectsBarUp(e);
        this._effectsSlider.touchendoutside = (e) => this.effectsBarUp(e);
  
        this._onButton.mousedown = this._onButton.touchstart = function () {
          if (self._active) {
            self.toggleSounds(false);
            self.onPressed(false);
          }
        };
        this._offButton.mousedown = this._offButton.touchstart = function () {
          if (self._active) {
            self.toggleSounds(true);
            self.onPressed(true);
          }
        };
  
        self.toggleSounds(true);
  
        Reflex.registerEventHandler(
          "orientationChange",
          this.orientationChange.bind(this)
        );
  
        this.orientationChange();
      }
  
      orientationChange() {
        this.setMusicSlider(this.musicPercent);
        this.setEffectsSlider(this.effectsPercent);
      }
  
      musicBarDown(e) {
        if (!this._active) return;
  
        const { originalEvent } = e.data;
        const clientX = !originalEvent.touches
          ? originalEvent.clientX
          : originalEvent.touches[0].clientX;
  
        this.lastPos = {
          x: clientX,
        };
  
        this._musicBarDown = true;
        this._effectsBarDown = false;
  
        this.musicBarMove(e);
      }
  
      musicBarUp() {
        if (!this._active) return;
  
        this._musicBarDown = false;
        this._musicCounter.visible = false;
      }
  
      musicBarMove(e) {
        if (!this._active) return;
  
        const { originalEvent } = e.data;
        var clientX = !originalEvent.touches
          ? originalEvent.clientX
          : originalEvent.touches[0].clientX;
  
        if (!clientX || !this.lastPos) return;
  
        if (this._musicBarDown) {
          this.lastDiffence = clientX - this.lastPos.x;
          this.lastPos.x = clientX;
  
          const width = gdk.getScreenWidth();
          const maxWidth = systemData.isLandscape ? 1280 : 720;
          const contw = this._musicSlider.width;
          const perfectRatio = contw / maxWidth;
          const ratio = contw / width / perfectRatio;
  
          this._musicSlider.x += this.lastDiffence * ratio;
  
          this.sliderCap(this._musicSlider);
          this.setMusicVolume(
            (this._musicSlider.x + this.backgroundWidth / 2) /
              this.backgroundWidth
          );
  
          this._musicCounter.visible = true;
          this._musicCounter.x = this._musicSlider.x;
        }
      }
  
      setMusicVolume(amount) {
        let round = Math.round(amount * 100);
        this.musicPercent = round / 100;
        soundManager.setMusicVolume(this.musicPercent);
        this._musicCounter.text = Math.round(this.musicPercent * 100);
      }
  
      setMusicSlider(percent) {
        this._musicSlider.x =
          this.backgroundWidth * percent - this.backgroundWidth / 2;
        this.musicPercent = percent;
        soundManager.setMusicVolume(percent);
      }
  
      effectsBarDown(e) {
        if (!this._active) return;
  
        const { originalEvent } = e.data;
        const clientX = !originalEvent.touches
          ? originalEvent.clientX
          : originalEvent.touches[0].clientX;
  
        this.lastPos = {
          x: clientX,
        };
  
        this._effectsBarDown = true;
        this._musicBarDown = false;
  
        this.effectsBarMove(e);
      }
  
      effectsBarUp() {
        if (!this._active) return;
  
        this._effectsBarDown = false;
        this._effectsCounter.visible = false;
      }
  
      effectsBarMove(e) {
        if (!this._active) return;
  
        const { originalEvent } = e.data;
        var clientX = !originalEvent.touches
          ? originalEvent.clientX
          : originalEvent.touches[0].clientX;
  
        if (!clientX || !this.lastPos) return;
  
        if (this._effectsBarDown) {
          this.lastDiffence = clientX - this.lastPos.x;
          this.lastPos.x = clientX;
  
          const width = gdk.getScreenWidth();
          const maxWidth = systemData.isLandscape ? 1280 : 720;
          const contw = this._effectsSlider.width;
          const perfectRatio = contw / maxWidth;
          const ratio = contw / width / perfectRatio;
  
          this._effectsSlider.x += this.lastDiffence * ratio;
  
          this.sliderCap(this._effectsSlider);
          this.setEffectsVolume(
            (this._effectsSlider.x + this.backgroundWidth / 2) /
              this.backgroundWidth
          );
  
          this._effectsCounter.visible = true;
          this._effectsCounter.x = this._effectsSlider.x;
        }
      }
  
      setEffectsVolume(amount) {
        let round = Math.round(amount * 100);
        this.effectsPercent = round / 100;
        soundManager.setEffectsVolume(this.effectsPercent);
        this._effectsCounter.text = Math.round(this.effectsPercent * 100);
      }
  
      setEffectsSlider(percent) {
        this._effectsSlider.x =
          this.backgroundWidth * percent - this.backgroundWidth / 2;
        this.effectsPercent = percent;
        soundManager.setEffectsVolume(percent);
      }
  
      setActive(active) {
        this._active = active;
      }
  
      sliderCap(slider) {
        slider.x = Math.min(
          Math.max(slider.x, -this.backgroundWidth / 2),
          this.backgroundWidth / 2
        );
      }
  
      onGameConfigEvent() {
        this.initialise();
      }
  
      toggleSounds(on) {
        if (this._onButton !== undefined) {
          this._onButton.visible = on;
          this._onButton.interactive = on;
        }
        if (this._offButton !== undefined) {
          this._offButton.visible = !on;
          this._offButton.interactive = !on;
        }
      }
  
      onAudioStateChanged(msg) {
        this.toggleSounds(!msg.muted);
      }
  
      onPressed(on) {
        soundManager.play("buttonPressed");
        messageBus.postImmediate("audio:stateChanged", {
          type: "audio:stateChanged",
          muted: !on,
        });
      }
    }
  
    var settingSoundCreator = function (json) {
      return new SettingSound(json);
    };
  
    var settingSoundInitialiser = function (json) {};
  
    var settingSoundFilesRequired = function () {
      return [];
    };
  
    resourceManager.registerObjectType(
      "settingSound",
      settingSoundCreator,
      settingSoundInitialiser,
      settingSoundFilesRequired
    );
  })();
  